import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js")